
<div
styleClass="pDialog"
[draggable]="false"
>
<div class="content">
  <img
    src="assets/lista-unidade/modal-inativar/inativar-unidade.svg"
    alt="imagem deletar unidade"
  />
  <span class="title">
    <p>Tem certeza que deseja</p>
    <p>inativar essa Unidade?</p>
  </span>
  <span class="message">
    <p>Ao confirmar você inativará todas as informações</p>
    <p>da Unidade selecionada</p>
  </span>
</div>
<ng-template pTemplate="footer">
  <button class="cancelar" (click)="fecharDialog()">
    Cancelar
  </button>
  <button class="inativar" (click)="disableCard(item)">
    Inativar
  </button>
</ng-template>
</div>
